export interface CountryCode {
  code: string;
  country: string;
  countryAr: string;
  flag: string;
}

export const countryCodes: CountryCode[] = [
  { code: "+20", country: "Egypt", countryAr: "مصر", flag: "🇪🇬" },
  { code: "+966", country: "Saudi Arabia", countryAr: "السعودية", flag: "🇸🇦" },
  { code: "+971", country: "United Arab Emirates", countryAr: "الإمارات", flag: "🇦🇪" },
  { code: "+965", country: "Kuwait", countryAr: "الكويت", flag: "🇰🇼" },
  { code: "+974", country: "Qatar", countryAr: "قطر", flag: "🇶🇦" },
  { code: "+973", country: "Bahrain", countryAr: "البحرين", flag: "🇧🇭" },
  { code: "+968", country: "Oman", countryAr: "عمان", flag: "🇴🇲" },
  { code: "+962", country: "Jordan", countryAr: "الأردن", flag: "🇯🇴" },
  { code: "+961", country: "Lebanon", countryAr: "لبنان", flag: "🇱🇧" },
  { code: "+963", country: "Syria", countryAr: "سوريا", flag: "🇸🇾" },
  { code: "+964", country: "Iraq", countryAr: "العراق", flag: "🇮🇶" },
  { code: "+967", country: "Yemen", countryAr: "اليمن", flag: "🇾🇪" },
  { code: "+970", country: "Palestine", countryAr: "فلسطين", flag: "🇵🇸" },
  { code: "+216", country: "Tunisia", countryAr: "تونس", flag: "🇹🇳" },
  { code: "+213", country: "Algeria", countryAr: "الجزائر", flag: "🇩🇿" },
  { code: "+212", country: "Morocco", countryAr: "المغرب", flag: "🇲🇦" },
  { code: "+218", country: "Libya", countryAr: "ليبيا", flag: "🇱🇾" },
  { code: "+249", country: "Sudan", countryAr: "السودان", flag: "🇸🇩" },
  { code: "+1", country: "United States", countryAr: "الولايات المتحدة", flag: "🇺🇸" },
  { code: "+1", country: "Canada", countryAr: "كندا", flag: "🇨🇦" },
  { code: "+44", country: "United Kingdom", countryAr: "المملكة المتحدة", flag: "🇬🇧" },
  { code: "+49", country: "Germany", countryAr: "ألمانيا", flag: "🇩🇪" },
  { code: "+33", country: "France", countryAr: "فرنسا", flag: "🇫🇷" },
  { code: "+39", country: "Italy", countryAr: "إيطاليا", flag: "🇮🇹" },
  { code: "+34", country: "Spain", countryAr: "إسبانيا", flag: "🇪🇸" },
  { code: "+31", country: "Netherlands", countryAr: "هولندا", flag: "🇳🇱" },
  { code: "+46", country: "Sweden", countryAr: "السويد", flag: "🇸🇪" },
  { code: "+47", country: "Norway", countryAr: "النرويج", flag: "🇳🇴" },
  { code: "+45", country: "Denmark", countryAr: "الدنمارك", flag: "🇩🇰" },
  { code: "+358", country: "Finland", countryAr: "فنلندا", flag: "🇫🇮" },
  { code: "+48", country: "Poland", countryAr: "بولندا", flag: "🇵🇱" },
  { code: "+380", country: "Ukraine", countryAr: "أوكرانيا", flag: "🇺🇦" },
  { code: "+90", country: "Turkey", countryAr: "تركيا", flag: "🇹🇷" },
  { code: "+91", country: "India", countryAr: "الهند", flag: "🇮🇳" },
  { code: "+92", country: "Pakistan", countryAr: "باكستان", flag: "🇵🇰" },
  { code: "+880", country: "Bangladesh", countryAr: "بنغلاديش", flag: "🇧🇩" },
  { code: "+62", country: "Indonesia", countryAr: "إندونيسيا", flag: "🇮🇩" },
  { code: "+60", country: "Malaysia", countryAr: "ماليزيا", flag: "🇲🇾" },
  { code: "+65", country: "Singapore", countryAr: "سنغافورة", flag: "🇸🇬" },
  { code: "+66", country: "Thailand", countryAr: "تايلاند", flag: "🇹🇭" },
  { code: "+84", country: "Vietnam", countryAr: "فيتنام", flag: "🇻🇳" },
  { code: "+81", country: "Japan", countryAr: "اليابان", flag: "🇯🇵" },
  { code: "+82", country: "South Korea", countryAr: "كوريا الجنوبية", flag: "🇰🇷" },
  { code: "+86", country: "China", countryAr: "الصين", flag: "🇨🇳" },
  { code: "+55", country: "Brazil", countryAr: "البرازيل", flag: "🇧🇷" },
  { code: "+52", country: "Mexico", countryAr: "المكسيك", flag: "🇲🇽" },
  { code: "+54", country: "Argentina", countryAr: "الأرجنتين", flag: "🇦🇷" },
  { code: "+61", country: "Australia", countryAr: "أستراليا", flag: "🇦🇺" },
  { code: "+27", country: "South Africa", countryAr: "جنوب أفريقيا", flag: "🇿🇦" },
  { code: "+234", country: "Nigeria", countryAr: "نيجيريا", flag: "🇳🇬" },
  { code: "+254", country: "Kenya", countryAr: "كينيا", flag: "🇰🇪" },
];